import { consola } from 'consola'
import { useAuthMonitor } from '@features/auth'

// Logger
const logger = consola.withTag('auth-monitor-plugin')

/**
 * Плагин для мониторинга состояния авторизации
 * 
 * Автоматически запускается при инициализации приложения
 * и следит за изменениями токенов авторизации
 */
export default defineNuxtPlugin(() => {
  if (!process.client) return
  
  const authMonitor = useAuthMonitor()
  
  // Запускаем мониторинг
  const stopMonitoring = authMonitor.startAuthMonitoring()
  
  // Проверяем текущее состояние
  authMonitor.checkCurrentAuthState()
  
  logger.success('Плагин мониторинга авторизации запущен')
  
  // Останавливаем мониторинг при размонтировании
  onUnmounted(() => {
    if (stopMonitoring) {
      stopMonitoring()
    }
  })
}) 